/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const RD_ADD_USER_PROFILE_COMMENT_RESET_VALUES = "RD_ADD_USER_PROFILE_COMMENT_RESET_VALUES";
export const RD_PROGRAM_PROFILE_UPDATE_RESET_STATUS = "RD_PROGRAM_PROFILE_UPDATE_RESET_STATUS";

export const RD_UPDATE_USER_PROFILE_ID = "RD_UPDATE_USER_PROFILE_ID";

export const RD_FETCH_PROGRAM_PROFILE = "RD_FETCH_PROGRAM_PROFILE";
export const RD_FETCH_PROGRAM_PROFILE_FAIL = "RD_FETCH_PROGRAM_PROFILE_FAIL";
export const RD_FETCH_PROGRAM_PROFILE_SUCCESS = "RD_FETCH_PROGRAM_PROFILE_SUCCESS";

export const RD_UPDATE_PROGRAM_PROFILE = "RD_UPDATE_PROGRAM_PROFILE";
export const RD_UPDATE_PROGRAM_PROFILE_SUCCESS = "RD_UPDATE_PROGRAM_PROFILE_SUCCESS";
export const RD_UPDATE_PROGRAM_PROFILE_FAIL = "RD_UPDATE_PROGRAM_PROFILE_FAIL";

export const RD_ADD_USER_PROFILE_COMMENT = "RD_ADD_USER_PROFILE_COMMENT";
export const RD_ADD_USER_PROFILE_COMMENT_SUCCESS = "RD_ADD_USER_PROFILE_COMMENT_SUCCESS";
export const RD_ADD_USER_PROFILE_COMMENT_FAIL = "RD_ADD_USER_PROFILE_COMMENT_FAIL";

export const RD_FETCH_USER_PROFILE_COMMENTS = "RD_FETCH_USER_PROFILE_COMMENTS";
export const RD_FETCH_USER_PROFILE_COMMENTS_SUCCESS = "RD_FETCH_USER_PROFILE_COMMENTS_SUCCESS";
export const RD_FETCH_USER_PROFILE_COMMENTS_FAIL = "RD_FETCH_USER_PROFILE_COMMENTS_FAIL";

export const RD_FETCH_USER_PROFILE = "RD_FETCH_USER_PROFILE";
export const RD_FETCH_USER_PROFILE_SUCCESS = "RD_FETCH_USER_PROFILE_SUCCESS";
export const RD_FETCH_USER_PROFILE_FAIL = "RD_FETCH_USER_PROFILE_FAIL";

export const RD_USER_PROFILES_SEARCH = "RD_USER_PROFILES_SEARCH";
export const RD_USER_PROFILES_SEARCH_SUCCESS = "RD_USER_PROFILES_SEARCH_SUCCESS";
export const RD_USER_PROFILES_SEARCH_FAIL = "RD_USER_PROFILES_SEARCH_FAIL";

export const RD_ADD_AZURE_BENEFIT_DETAIL = "RD_ADD_AZURE_BENEFIT_DETAIL";
export const RD_ADD_AZURE_BENEFIT_DETAIL_SUCCESS = "RD_ADD_AZURE_BENEFIT_DETAIL_SUCCESS";
export const RD_ADD_AZURE_BENEFIT_DETAIL_FAIL = "RD_ADD_AZURE_BENEFIT_DETAIL_FAIL";
export const RD_ADD_AZURE_BENEFIT_RESET = "RD_ADD_AZURE_BENEFIT_RESET";

export const RD_USER_PROFILES_FILTER_VALUE_ADD = "RD_USER_PROFILES_FILTER_VALUE_ADD";
export const RD_USER_PROFILES_FILTER_VALUE_REMOVE = "RD_USER_PROFILES_FILTER_VALUE_REMOVE";
export const RD_USER_PROFILES_FILTER_PROVINCE_VALUE_REMOVE =
  "RD_USER_PROFILES_FILTER_PROVINCE_VALUE_REMOVE";
export const RD_USER_PROFILES_FILTER_VALUE_UPDATE = "RD_USER_PROFILES_FILTER_VALUE_UPDATE";
export const RD_USER_PROFILES_FILTER_VALUE_RESET = "RD_USER_PROFILES_FILTER_VALUE_RESET";

export const RD_DOWNLOAD_TO_CSV = "RD_DOWNLOAD_TO_CSV";
export const RD_DOWNLOAD_TO_CSV_SUCCESS = "RD_DOWNLOAD_TO_CSV_SUCCESS";
export const RD_DOWNLOAD_TO_CSV_FAIL = "RD_DOWNLOAD_TO_CSV_FAIL";

export const RD_UPDATE_LISTING_SORTING = "RD_UPDATE_LISTING_SORTING";
export const RD_UPDATE_LISTING_CURRENT_PAGE = "RD_UPDATE_LISTING_CURRENT_PAGE";
export const RD_UPDATE_LISTING_PAGE_SIZE = "RD_UPDATE_LISTING_PAGE_SIZE";
export const RD_RESET_FILE_DOWNLOAD_STATUS = "RD_RESET_FILE_DOWNLOAD_STATUS";

export const RD_USER_PROFILE_CLAIM_BENEFIT = "RD_USER_PROFILE_CLAIM_BENEFIT";
export const RD_USER_PROFILE_CLAIM_BENEFIT_FAIL = "RD_USER_PROFILE_CLAIM_BENEFIT_FAIL";
export const RD_USER_PROFILE_CLAIM_BENEFIT_SUCCESS = "RD_USER_PROFILE_CLAIM_BENEFIT_SUCCESS";
export const RD_USER_PROFILE_CLAIM_BENEFIT_RESET = "RD_USER_PROFILE_CLAIM_BENEFIT_RESET";
export const RD_GET_PROFILE_BENEFITS = "RD_GET_PROFILE_BENEFITS";
export const RD_GET_PROFILE_BENEFITS_SUCCESS = "RD_GET_PROFILE_BENEFITS_SUCCESS";
export const RD_GET_PROFILE_BENEFITS_FAIL = "RD_GET_PROFILE_BENEFITS_FAIL";

export const RD_RESET_M365_BENEFIT_DETAIL = "RD_RESET_M365_BENEFIT_DETAIL";

export const RD_GET_M365_BENEFIT_DETAIL = "RD_GET_M365_BENEFIT_DETAIL";
export const RD_GET_M365_BENEFIT_DETAIL_SUCCESS = "RD_GET_M365_BENEFIT_DETAIL_SUCCESS";
export const RD_GET_M365_BENEFIT_DETAIL_FAILURE = "RD_GET_M365_BENEFIT_DETAIL_FAILURE";

export const RD_UPDATE_M365_BENEFIT_DETAIL = "RD_UPDATE_M365_BENEFIT_DETAIL";
export const RD_UPDATE_M365_BENEFIT_DETAIL_SUCCESS = "RD_UPDATE_M365_BENEFIT_DETAIL_SUCCESS";
export const RD_UPDATE_M365_BENEFIT_DETAIL_FAILURE = "RD_UPDATE_M365_BENEFIT_DETAIL_FAILURE";

export const RD_RESET_MS365_BENEFIT_DETAIL = "RD_RESET_MS365_BENEFIT_DETAIL";

export const RD_GET_MS365_BENEFIT_DETAIL = "RD_GET_MS365_BENEFIT_DETAIL";
export const RD_GET_MS365_BENEFIT_DETAIL_SUCCESS = "RD_GET_MS365_BENEFIT_DETAIL_SUCCESS";
export const RD_GET_MS365_BENEFIT_DETAIL_FAILURE = "RD_GET_MS365_BENEFIT_DETAIL_FAILURE";

export const RD_UPDATE_MS365_BENEFIT_DETAIL = "RD_UPDATE_MS365_BENEFIT_DETAIL";
export const RD_UPDATE_MS365_BENEFIT_DETAIL_SUCCESS = "RD_UPDATE_MS365_BENEFIT_DETAIL_SUCCESS";
export const RD_UPDATE_MS365_BENEFIT_DETAIL_FAILURE = "RD_UPDATE_MS365_BENEFIT_DETAIL_FAILURE";

export const RD_GET_TEAMS_BENEFIT_DETAIL = "RD_GET_TEAMS_BENEFIT_DETAIL";
export const RD_GET_TEAMS_BENEFIT_DETAIL_SUCCESS = "RD_GET_TEAMS_BENEFIT_DETAIL_SUCCESS";
export const RD_GET_TEAMS_BENEFIT_DETAIL_FAILURE = "RD_GET_TEAMS_BENEFIT_DETAIL_FAILURE";

export const RD_EXTEND_AZURE_BENEFIT_CREDIT = "RD_EXTEND_AZURE_BENEFIT_CREDIT";
export const RD_EXTEND_AZURE_BENEFIT_CREDIT_SUCCESS = "RD_EXTEND_AZURE_BENEFIT_CREDIT_SUCCESS";
export const RD_EXTEND_AZURE_BENEFIT_CREDIT_FAILURE = "RD_EXTEND_AZURE_BENEFIT_CREDIT_FAILURE";
export const RD_EXTEND_AZURE_BENEFIT_CREDIT_RESET = "RD_EXTEND_AZURE_BENEFIT_CREDIT_RESET";

export const RD_USERPROFILE_UPDATE_IS_PRIVATE = "RD_USERPROFILE_UPDATE_IS_PRIVATE";
export const RD_USERPROFILE_UPDATE_IS_PRIVATE_FAIL = "RD_USERPROFILE_UPDATE_IS_PRIVATE_FAIL";
export const RD_USERPROFILE_UPDATE_IS_PRIVATE_SUCCESS = "RD_USERPROFILE_UPDATE_IS_PRIVATE_SUCCESS";

export const RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL = "RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL";
export const RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL_SUCCESS =
  "RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL_SUCCESS";
export const RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL_FAIL =
  "RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL_FAIL";
export const RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL_RESET =
  "RD_USER_PROFILE_UPDATE_PRIMARY_EMAIL_RESET";
